import { render } from "./DepositBonus.vue?vue&type=template&id=9a1141d0&scoped=true"
import script from "./DepositBonus.vue?vue&type=script&lang=js"
export * from "./DepositBonus.vue?vue&type=script&lang=js"

import "./DepositBonus.vue?vue&type=style&index=0&id=9a1141d0&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1141d0"]])

export default __exports__